import React from 'react';

import styles from './ProjectScratchpad.module.scss';

export interface ScratchpadContentProps {
  text?: string;
  className?: string;
  emptyClassName?: string;
}

export function ScratchpadContent(props: ScratchpadContentProps) {
  if (props.text) {
    return (
      <div className={props.className || styles.content}>
        {props.text}
      </div>
    );
  } else {
    return (
      <div className={props.emptyClassName || styles.emptyContent}>
        Jot down quick reminders.
      </div>
    );
  }
}
